<template>
  <div id="app">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="计算机科学">计算机科学</el-menu-item>
      <el-menu-item index="材料科学">材料科学</el-menu-item>
      <el-menu-item index="电子电工">电子电工</el-menu-item>
      <el-menu-item index="教育学">教育学</el-menu-item>
      <el-menu-item index="图书情报">图书情报</el-menu-item>
      <el-menu-item index="合成生物学">合成生物学</el-menu-item>
      <el-menu-item index="人工智能">人工智能</el-menu-item>
      <el-menu-item index="机械工程">机械工程</el-menu-item>
    </el-menu>

    <ul class="aside_al">
      <li
        class="plcont"
        v-for="(item, index) in Collectionlist.slice(0, 10)"
        :key="index"
        @click="change(item)"
      >
        <div class="plcont_top">
          <img :src="item.img" class="ing" />

          <div class="title">{{ item.name }}</div>
          <div class="score">
            等级<span class="red"> {{ item.level }}</span
            >级
          </div>
        </div>
        <div class="cawd">
          <div class="bq">
            <span v-for="item in item.keyword" :key="item"
              >{{ item }}&emsp;</span
            >
          </div>
          <div class="content">{{ item.content }}</div>
          <div>
            <span class="down" style="width:10%">{{ item.Time }}上传</span>
            <span class="down">|</span
            ><span class="down">共{{ item.pageall }}页</span
            ><span class="down">|</span>
            <span class="down">{{ item.download }}下载</span
            ><span class="down">|</span
            ><span class="down">{{ item.Price }}知识币</span
            ><span class="down">|</span
            ><span class="down" style="width:15%;text-align: left;"
              >作者:{{ item.UserauthorName }}</span
            >
            <el-button type="primary" size="small" @click.stop="downd(item)"
              >下载</el-button
            >
          </div>
        </div>
      </li>
      <div class="block" style="    text-align: center;">
        <el-pagination
          layout="prev, pager, next"
          :total="totlePage"
          :page-size="pageSize"
          @current-change="currentPage"
        >
        </el-pagination>
      </div>
    </ul>
  </div>
</template>

<script>
import { INSERT, QUERY, DELETE } from "@/services/dao.js";
import {getYMD } from "@/js/common";
import { updateread } from "@/js/common/Resoures";
export default {
  components: {},
  data() {
    return {
      img: require("@/assets/img/WORD.png"),
      name: "利用python进行数据分析",
      score: "4.5",
      read: "3w",
      download: "590",
      time: "2020-6-3",
      page: "14",
      size: "168kb",
      url:
        "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2594104736,4220653550&fm=26&gp=0.jpg",
      Price: "30",
      content:
        "这种用整数表示的方法称为分类或字典编码表示法。不同值得数组称为分类、字典或数据级。本书中，我们使用分类的说法。表示分类的整数值称为分类编码或简单地称为编码。分类表示可以在进行分析时大大的提高性能。你也可以在保持编码不变的情况下，对分类进行转换。一些相对简单的转变例子包括重命名分类。加入一个新的分类，不改变已经存在的分类的顺序或位置。pandas的分类类型pandas有一个特殊的分类类型，用于保存使用整数分类表示法的数据。看一个之前的Series例子：",
      list: ["数据分析", "实用科学", "计算机", "编译器"],
      Collection: "2",
      comment: "3",
      circleurl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      sizeList: ["large", "medium", "small"],
      user: "aaaaaaaa",
      value1: null,
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      Collectionlist: [],
      initiallist: [],
      activeIndex: "1",
      pageNum: 0,
      pageSize: 10, //原来是10
      searchWord: "",
      totlePage: 0,
    };
  },
  created() {
    this.init(this.pageSize, this.pageSize * this.pageNum);

    console.log(this.initiallist);
  },
  methods: {
    async init(limit, offest) {
      let res = await QUERY(
        "post",
        "",
        "ZYDocument(limit: " +
          limit +
          ", offset: " +
          offest +
          ', where: {classification: {_like: "%' +
          this.searchWord +
          '%"}}){  level  name  format id  read   score  user keyword  pageall  download  content  Time  Price classification UserauthorName} ZYDocument_aggregate(where: {}){    aggregate {      count    }  }'
      );
      this.totlePage = res.data.ZYDocument_aggregate.aggregate.count;
      for (let i = 0; i < res.data.ZYDocument.length; i++) {
        // res.data.ZYDocument[i].Time = res.data.ZYDocument[i].Time
        res.data.ZYDocument[i].Time = getYMD(
          Date.parse(res.data.ZYDocument[i].Time)
        );
        res.data.ZYDocument[i].keyword = eval(res.data.ZYDocument[i].keyword);
        switch (res.data.ZYDocument[i].format) {
          case "docx":
            res.data.ZYDocument[i].img = require("@/assets/icon/WORD@2x.png");
            break;
          case "txt":
            res.data.ZYDocument[i].img = require("@/assets/icon/txt(1)@2x.png");
            break;
          case "pdf":
            res.data.ZYDocument[i].img = require("@/assets/icon/PDF48@2x.png");
            break;
          case "mp3":
            res.data.ZYDocument[i].img = require("@/assets/img/MP3.png");
            break;
          case "mp4":
            res.data.ZYDocument[i].img = require("@/assets/img/MP4.png");
            break;
          case "jpg":
            res.data.ZYDocument[i].img = require("@/assets/icon/？@2x.png");
            break;
          case "jpeg":
            res.data.ZYDocument[i].img = require("@/assets/icon/？@2x.png");
            break;
          case "png":
            res.data.ZYDocument[i].img = require("@/assets/icon/？@2x.png");
            break;
          case "excel":
            res.data.ZYDocument[
              i
            ].img = require("@/assets/icon/excel(2) 拷贝@2x.png");
            break;
          case "ppt":
            res.data.ZYDocument[i].img = require("@/assets/icon/ppt@2x.png");
            break;
          default:
            res.data.ZYDocument[i].img = require("@/assets/icon/？@2x.png");
        }
      }
      this.Collectionlist = res.data.ZYDocument;
      this.initiallist = this.Collectionlist;
    },
    downd(item) {
      if (
        this.$store.state.userinfo.id < 0 ||
        this.$store.state.userinfo.id == "" ||
        this.$store.state.userinfo.id == null ||
        this.$store.state.userinfo.id == "undefined"
      ) {
        this.$message({
          message: "请您先登录！",
          type: "warning",
          duration: "1000",
        });
      } else {
        this.$router.push({
          path: "/Resource_download",
          query: {
            id: item.id,
          },
        });
      }
    },
    change(item) {
      updateread(item.id, item.read);
      let user = this.$store.state.userinfo.id;
      // integralAddOne(user); ///积分加1
      this.$router.push({
        path: "/Resource_details",
        query: {
          id: item.id,
        },
      });
    },
    currentPage(val) {
      this.pageNum = val - 1;
      this.init(this.pageSize, this.pageSize * this.pageNum);
    },
    handleSelect(key, keyPath) {
      this.searchWord = key;
      this.init(this.pageSize, this.pageSize * this.pageNum);
    },
  },
};
</script>
<style scoped>
.el-menu--horizontal > .el-menu-item {
  width: 12.5%;
  background-color: #0e86f6;
  color: #ffffff;
}
.el-menu-demo {
  margin-top: 37px;
}
.plcont {
  width: 100%;
  overflow: hidden;
  padding-bottom: 14px;
  padding-top: 14px;
  border-bottom: 1px solid #f7f7f7;
}
.plcont .ing {
  width: 25px;
  height: 28px;
  margin-right: 10px;
  float: left;
}
.plcont .title {
  float: left;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(2, 2, 2, 1);
  border-radius: 999999px;
}
.cawd {
  margin-top: 5px;
  width: 100%;
  margin-top: 0.036765rem;
  position: relative;
}
.cawd .down {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(83, 83, 83, 1);
  line-height: 23px;
  width: 7%;
  text-align: center;
  /* position: absolute; */
  float: left;
}
.aside_al {
  background-color: #ffffff;
}
.aside_rm {
  margin-top: 40px;
  background-color: #ffffff;
}
.aside_rm .header {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  padding: 10px;
  /* margin: 10px; */
  border-bottom: 1px solid #f7f7f7;
}
.rm_center .plcont {
  margin-left: -10px;
}
.rm_center .plcont .index {
  float: left;
  padding: 10px;
  background-color: #f7f7f7;
  margin-right: 10px;
}
.rm_li .down {
  margin-right: 20px;
}
.plcont_top {
  cursor: pointer;
  line-height: 40px;
  overflow: hidden;
}
.plcont_top .score {
  margin-right: 60px;
  float: right;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(2, 2, 2, 1);
}
.plcont_top .score .red {
  color: red;
}
.bq {
  line-height: 30px;
}
.bq span {
  border-radius: 30px;
  border: 0.007353rem solid #bfbfbf;
  /* padding: 0.036765rem; */
  margin-left: 5px;
  background-color: #eeeeee;
  padding: 2px 10px 2px 10px;
}
.plcont .content {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: rgba(0, 0, 0, 1);
  line-height: 25px;
}
.plcont button {
  margin-right: 60px;
  float: right;
}
#app {
  width: 80%;
  margin: 0 auto;
}
#app >>> .el-menu .el-menu-item {
  font-size: 14px;
}
</style>
